// The auth backend exposes the same four actions under two controllers:
//   - "login"           for local email/password users
//   - "activeDirectory" for AD/LDAP users
// The login screen picks the controller based on the route.

export type AuthController = 'login' | 'activeDirectory';

export interface LoginEndpoints {
    credentials: string;
    authy: string;
    email: string;
    optCode: string;
}

export function getLoginEndpoints(controller: AuthController): LoginEndpoints {
    return {
        credentials: `${controller}/CheckCredentials`,
        authy: `${controller}/ContinueWithAuthy`,
        email: `${controller}/ContinueWithEmail`,
        optCode: `${controller}/VerifyOptCode`,
    };
}
